import koLocale from 'element-ui/lib/locale/lang/ko'
import home from './ko/home'

const ko = {
    language: '한국어',
    message: {
        'home': {
            ...home,
            enterEmail: '이메일을 입력하세요',
            save: '저장',
            saveSuccess: '저장되었습니다',
            pointHistory: '포인트 내역',
            type: '유형',
            remark: '비고',
            pendingComment: '미평가',
            commented: '평가 완료',
            selectDate: '날짜 선택',
            loginSuccess: '로그인 성공',
            loginFail: '로그인 실패',
            close: '닫기',
            required: '필수',
            nickname: '닉네임',
            enterNickname: '닉네임을 입력하세요',
            gender: '성별',
            male: '남성',
            female: '여성',
            secret: '비공개',
            birthday: '생일',
            checkoutLoadFailed: '결제 정보를 불러오지 못했습니다. 잠시 후 다시 시도하세요.',
            checkoutErrorTitle: '안내',
            goAddAddress: '배송지 추가',
            shop_order_selectOrAddAddress: '먼저 배송지를 추가하고 기본 배송지로 설정한 후 결제하세요.',
            shop_order_cartEmpty: '장바구니가 비어 있어 결제할 수 없습니다.',
            shop_order_cartHasNotActive: '미등록 또는 유효하지 않은 상품이 있어 결제할 수 없습니다.',
            shop_order_cartHasNotMarketable: '판매 중지된 상품이 있어 결제할 수 없습니다.',
            shop_order_cartHasLowStock: '재고가 부족하여 결제할 수 없습니다.',
            shop_order_cartHasExpiredGoods: '일부 매장 상품이 만료되어 결제할 수 없습니다.',
            shop_order_typeIsNull: '주문 유형을 인식할 수 없습니다. 상품 유형을 확인하세요.',
            shop_order_goodsNotFound: '상품 정보가 없거나 삭제되었습니다.',
            shop_order_giftNotForSale: '사은품은 직접 구매할 수 없습니다.',
            common_message_badRequest: '잘못된 요청입니다. 상품과 매개변수를 확인하세요.',
        },
    },
    '手机号码最小长度为8位': '휴대전화 번호의 최소 길이는 8자리입니다',
    '邮箱账号名称最小长度为6位': "이메일 계정 이름의 최소 길이는 6자입니다",
    '邮箱只能包含英文，数字等字符': "우편함은 영문, 숫자 등의 문자만 포함할 수 있습니다",
    '请选择正确的收货地址': "올바른 배송 주소를 선택하세요",
    Dict_language_status_0: '비활성화',
    Dict_language_status_1: '활성화',
    Dict_member_label_type_1: '조건 라벨',
    Dict_member_label_type_2: '수동 라벨',
    Dict_member_level_type_0: '소비 등급 (LV)',
    Dict_member_level_type_1: '유료 회원 (VIP)',
    Dict_member_growth_action_type_1: '주문하기',
    Dict_member_growth_action_type_2: '매일 로그인',
    Dict_member_growth_action_type_3: '리뷰 작성',
    Dict_member_growth_action_type_4: '프로필 작성',
    Dict_paid_member_payment_type_0: '잔액 결제',
    Dict_paid_member_payment_type_1: 'WeChat Pay',
    Dict_paid_member_payment_type_2: 'Alipay',
    Dict_paid_member_payment_type_3: 'PayPal',
    Dict_paid_member_record_status_0: '유효',
    Dict_paid_member_record_status_1: '만료됨',
    Dict_paid_member_record_status_2: '환불됨',
    Dict_point_lottery_prize_type_0: '포인트',
    Dict_point_lottery_prize_type_1: '쿠폰',
    Dict_point_lottery_prize_type_2: '실물 상품',
    Dict_point_lottery_prize_type_3: '참여해 주셔서 감사합니다',
    Dict_notification_channel_type_0: 'SMS',
    Dict_notification_channel_type_1: '이메일',
    Dict_notification_channel_type_2: '사이트 내 메시지',
    Dict_notification_channel_type_3: '푸시 알림',
    Dict_announcement_status_0: '초안',
    Dict_announcement_status_1: '게시됨',
    Dict_announcement_status_2: '게시 중단',
    Dict_live_permission_status_0: '미신청',
    Dict_live_permission_status_1: '심사 중',
    Dict_live_permission_status_2: '개통됨',
    Dict_live_permission_status_3: '거절됨',
    Dict_live_room_status_0: '시작 전',
    Dict_live_room_status_1: '방송 중',
    Dict_live_room_status_2: '종료됨',
    Dict_live_room_status_3: '비정상 중단',
    Dict_live_room_type_0: '플랫폼 방송',
    Dict_live_room_type_1: '판매자 방송',
    Dict_store_type_0: '개인 상점',
    Dict_store_type_1: '기업 상점',
    Dict_store_sign_status_0: '계약 대기',
    Dict_store_sign_status_1: '계약 완료',
    Dict_store_sign_status_2: '해지',
    Dict_store_business_change_status_0: '심사 대기',
    Dict_store_business_change_status_1: '심사 통과',
    Dict_store_business_change_status_2: '심사 거절',
    Dict_decoration_page_type_0: '홈',
    Dict_decoration_page_type_1: '카테고리 페이지',
    Dict_decoration_page_type_2: '이벤트 페이지',
    Dict_decoration_page_type_3: '사용자 정의 페이지',
    Dict_decoration_status_0: '초안',
    Dict_decoration_status_1: '게시됨',
    Dict_decoration_popup_trigger_page_0: '플랫폼 홈',
    Dict_decoration_popup_trigger_page_1: '회원 센터',
    Dict_decoration_popup_trigger_page_2: '결제 성공',
    Dict_decoration_popup_target_user_0: '모든 사용자',
    Dict_decoration_popup_target_user_1: '무료 회원',
    Dict_decoration_popup_target_user_2: '유료 회원',
    Dict_decoration_popup_frequency_0: '영구히 한 번',
    Dict_decoration_popup_frequency_1: '방문할 때마다',
    Dict_decoration_popup_frequency_2: '사용자 정의 빈도',
    Dict_track_event_type_page_view: '페이지 조회',
    Dict_track_event_type_click: '클릭',
    Dict_track_event_type_add_to_cart: '장바구니 담기',
    Dict_track_event_type_search: '검색',
    Dict_track_event_type_purchase: '구매',
    Dict_track_event_type_live_watch: '라이브 시청',
    Dict_reconcile_period_type_0: '일별',
    Dict_reconcile_period_type_1: '주별',
    Dict_reconcile_period_type_2: '월별',
    Dict_store_settlement_status_0: '정산 대기',
    Dict_store_settlement_status_1: '정산 완료',
    Dict_distributor_status_0: '심사 대기',
    Dict_distributor_status_1: '심사 완료',
    Dict_distributor_status_2: '거절됨',
    Dict_distribution_commission_type_0: '직접 커미션',
    Dict_distribution_commission_type_1: '간접 커미션',
    Dict_configuration_status_0: '비활성화',
    Dict_configuration_status_1: '활성화',
    ...koLocale
}
export default ko
